import React from "react"
import { useTranslation } from "gatsby-plugin-react-i18next"
import {
  Container,
  Section,
  SectionHead,
  ReadMore,
} from "src/components/common"
import {
  List,
  Row,
  Aside,
  Body,
  StackLine,
  Lead,
  For,
  Benefits,
  Details,
} from "./styles"

export const Services = () => {
  const { t } = useTranslation()
  const items = t("services:items", { returnObjects: true })

  return (
    <Section id="services" aria-labelledby="services-title">
      <Container>
        <SectionHead
          id="services-title"
          title={t("services:headline")}
          lead={t("services:lead")}
        />
        <List>
          {items.map(item => (
            <Row key={item.id} id={`service-${item.id}`}>
              <Aside>
                <h3>{item.title}</h3>
                <StackLine>{item.tags.join(", ")}</StackLine>
              </Aside>
              <Body>
                <Lead>{item.lead}</Lead>
                <For>
                  <strong>{t("services:for_label")}:</strong> {item.for}
                </For>
                <Benefits>
                  {item.benefits.map((benefit, index) => (
                    <li key={index}>{benefit}</li>
                  ))}
                </Benefits>
                <ReadMore id={`service-${item.id}-details`}>
                  <Details>
                    {item.details.map((detail, index) => (
                      <div key={index}>
                        <h4>{detail.title}</h4>
                        <p>{detail.content}</p>
                      </div>
                    ))}
                  </Details>
                </ReadMore>
              </Body>
            </Row>
          ))}
        </List>
      </Container>
    </Section>
  )
}
